import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Palette, API_BASE } from "../AppConfig";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import ReactTimeAgo from "react-time-ago";
import { changePage, DESIGNER_PAGE, saveUserToWeb, updateUserFromWeb } from "../redux_store/appState";
import {
    updateDesigner,
    resetDesigner,
    SHOW_LOADING_BACKDROP,
    setDesignerLoadingBackdrop,
} from "../redux_store/appState";
import { loadJob } from "../redux_store/jobState";
import BSL_StatusChip from "../components/BSL_StatusChip";
import { ContextMenu, ContextMenuItem } from "../components/BSL_ContextMenu";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { updateAPP, MAIN_PAGE } from "../redux_store/appState";
import ErrorIcon from "@material-ui/icons/Error";
import { BaseURL } from "../components/Common";

const columns = [
    // { id: 'DistributorName', label: 'Distributor', minWidth: 100 },
    {
        id: "Pin",
        label: "PIN",
    },
    { id: "Thumbnail", label: "" },
    {
        id: "Customer.JobName",
        label: "Job\u00a0Name",
        style: {
            color: Palette.FieldersBlue,
            fontWeight: window.FIELDERS ? "600" : "inherit",
        },
        // minWidth: 140,
        // align: 'right',
        format: (value) => value.toLocaleString("en-US"),
    },
    {
        id: "Customer.FirstName",
        label: "First\u00a0Name",
        // minWidth: 140,
        // align: 'right',
        format: (value) => value.toLocaleString("en-US"),
    },
    {
        id: "Customer.LastName",
        label: "Last\u00a0Name",
        // minWidth: 140,
        // align: 'right',
        format: (value) => value.toLocaleString("en-US"),
    },
    {
        id: "Address.FormattedStreetAddress",
        label: "Site\u00a0Street\u00a0Address",
        // minWidth: 170,
        // align: 'right',
    },
    {
        id: "Address.Suburb",
        label: "Site\u00a0Suburb",
        // minWidth: 170,
        // align: 'right',
    },
    {
        id: "DesignSummary",
        label: "Structure\u00a0Type",
        // minWidth: 170,
        // align: 'right',
        format: (value) => value.replace("/n", <br />),
    },
    {
        id: "id",
        label: "JOB\u00a0#",
        minWidth: 100,
        format: (value) => "#" + value,
    },
    {
        id: "Status",
        label: "Status",
    },
    {
        id: "_ts",
        label: "Last Edited",
        minWidth: 100,
        format: (value, row) => {
            //
            let date = new Date(value * 1000);
            //
            return (
                <>
                    {row?.UserCode ? "by " + row?.UserCode + " " : ""}
                    <ReactTimeAgo date={date} locale="en-AU" timeStyle="round" />
                </>
            );
        },
    },
];

const useStyles = makeStyles((theme) => ({
    root: {
        // height: '95%',
        flex: "1",
        width: "100%",
        maxHeight: "100%",
        margin: "10px 10px",
        color: theme.brand.FIELDERS ? "inherit" : Palette.Lysaght.MidGrey,
    },
    container: {
        // maxHeight: "calc(100% - 55px)",
    },
    rowCell: {
        fontSize: "12px",
        border: "none",
        padding: "2px 0px 2px 24px",
        color: theme.brand.FIELDERS ? "inherit" : Palette.Lysaght.MidGrey,
    },
    headingCell: {
        fontSize: "11px",
        border: "none",
        padding: "0px 0px 0px 24px",
        textTransform: "uppercase",
        color: Palette.FieldersBlue,
        fontWeight: theme.brand.FIELDERS ? "inherit" : "600",
    },
    thumbnail: {
        // ⚠️ object-fit is not supported by IE 11.
        objectFit: "contain",
        width: "32px",
        height: "32px",
    },
    hideImage: {
        objectFit: "contain",
        visibility: "hidden",
        display: "flex",
        padding: "0px",
        margin: "0px",
        transition: "all 0.2s ease",
        maxWidth: "0px",
    },
    showImage: {
        objectFit: "contain",
        display: "flex",
        padding: "0px",
        margin: "0px",
        transition: "all 0.2s ease",
        maxWidth: "400px",
        maxHeight: "400px",
    },
    thumbnailTooltip: {
        // ⚠️ object-fit is not supported by IE 11.
        transition: "all 0.2s ease",
        objectFit: "contain",
        display: "flex",
        padding: "0px",
        margin: "0px",
        maxWidth: "400px",
        maxHeight: "400px",
        width: "100%",
        flex: 1,
        zIndex: 999,
    },
    editButton: {
        cursor: "pointer",
        color: Palette.FieldersBlue,
        "&:hover": {
            backgroundColor: "#d5d5d5",
            cursor: "pointer",
        },
    },
    moreButton: {
        padding: "0px",
        borderRadius: "0%",
    },
    no_job_message: {
        width: "100%",
        height: "100px",
        textAlign: "center",
        paddingTop: "40px",
        fontStyle: "italic",
        color: "grey",
        fontSize: "20px",
    },
}));

export default function RecallTable(props) {
    //
    const classes = useStyles();
    const { searchFilter, businessCode, show_archived_list, noJobMessage } = props;
    // const [page, setPage] = React.useState(0);
    const page = 0;
    const [menuAnchor, setMenuAnchor] = React.useState(null);
    const [menuJobId, setMenuJobId] = React.useState(null);
    const [loadingJobClicked, setLoadingJobClicked] = React.useState(false);
    // const [rowsPerPage, setRowsPerPage] = React.useState(Math.trunc((window.innerHeight-300)/40));
    // const [rowsPerPage, setRowsPerPage] = React.useState(1000);
    const rowsPerPage = 1000;

    const [open, setOpen] = React.useState(false);
    const [img_url_show, setimg_url_show] = React.useState(false);
    const [showImage, setShowImage] = React.useState({ visible: false, image: "" });
    const user = useSelector((state) => state.app.user);
    const logged_user_code = useSelector((state) => state.app.logged_user_code);
    // const pinnedJobs = user?.pinned_jobs ?? [];
    // const user_id = user.id;
    let business_code = user.BusinessDetails.Code;
    if (businessCode) business_code = businessCode;

    const handleMenuClick = (event, id) => {
        setMenuAnchor(event.currentTarget);
        setMenuJobId(id);
    };

    const handleMenuClose = () => {
        setMenuAnchor(null);
    };

    const handleDuplicateQuote = () => {
        dispatch(loadJob(business_code, menuJobId, user)).then(() => {
            dispatch(updateAPP(MAIN_PAGE, { page: "Duplicate" }));
        });
    };

    const handlePinJob = () => {
        // Close menu
        handleMenuClose();

        // Update User State With Pinned / UnPinned
        dispatch(updateUserFromWeb(logged_user_code)).then((user_data) => {
            let pinned_jobs = user_data?.pinned_jobs ?? [];
            const selectedJob = menuJobId;

            // Check if user pinned already
            if (pinned_jobs.includes(selectedJob)) {
                // Remove Pinned Job and save user data, through filter
                // (can be changed to indexing, for performance improvements)
                pinned_jobs = pinned_jobs.filter((e) => e !== selectedJob);
            } else {
                pinned_jobs.push(selectedJob);
            }

            let new_user_data = {
                ...user_data,
                pinned_jobs,
            };

            dispatch(saveUserToWeb(new_user_data, true, false));
        });
    };

    // const CustomTooltip = withStyles({
    //     tooltip: {
    //         color: "write",
    //         backgroundColor: "white",
    //         fontWeight: "bold",
    //         fontSize: "12px",
    //         border: "1px solid #8A8B8A",
    //         maxWidth: "400px",
    //         marginLeft: "200px",
    //         "& > span": {
    //             left: "5px !important",
    //             color: "#8A8B8A",
    //         },
    //     },
    // })(Tooltip);

    //   React.useEffect(() => {
    //     function handleResize() {
    //       setRowsPerPage(Math.trunc((window.innerHeight-300)/40));
    // }

    //     window.addEventListener('resize', handleResize)
    //   })

    const handleClickOpen = (img) => {
        setimg_url_show(img);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const dispatch = useDispatch();

    const openJob = (event, id, name) => {
        if (loadingJobClicked) return;
        setLoadingJobClicked(true);

        dispatch(changePage(DESIGNER_PAGE));
        dispatch(setDesignerLoadingBackdrop("Loading #" + id + " - " + name));

        dispatch(loadJob(business_code, id, user, props?.containerMode ? props?.containerMode : "")).then((result) => {
            if (!result) {
                dispatch(
                    setDesignerLoadingBackdrop(
                        <div onClick={() => openJob(event, id, name)}>
                            <ErrorIcon style={{ fontSize: 40, color: "#ffa8a8" }} />
                            <br />
                            <Typography variant="overline" gutterBottom style={{ marginTop: "100px" }}>
                                <span>
                                    Error Loading # {id} - {name} ... try again?
                                </span>
                            </Typography>
                        </div>
                    )
                );
                setLoadingJobClicked(false);
            } else {
                dispatch(updateDesigner(SHOW_LOADING_BACKDROP, false));
                dispatch(resetDesigner());
                setLoadingJobClicked(false);
            }
        });
    };

    let rows = [];
    if (props.jobs !== undefined) rows = props.jobs;

    function MouseOver(id, event) {
        let srcImage = API_BASE() + "svg/" + id + "/layout.svg";
        let posY = event.clientY + window.pageYOffset;

        if (event.clientY < 325) {
            posY -= 50;
        } else {
            posY -= 200;
        }

        setShowImage({
            image: srcImage,
            positionX: event.clientX + 25,
            positionY: posY,
            visible: true,
        });
    }
    function MouseOut(id, event) {
        setShowImage({ ...showImage, visible: false });
    }

    const addImagePop = () => (
        <div
            className={showImage.visible ? classes.showImage : classes.hideImage}
            style={{
                background: "white",
                border: "1px solid black",
                opacity: 1,
                position: "absolute",
                zIndex: "9999",
                left: showImage.positionX,
                top: showImage.positionY,
            }}
        >
            <img
                className={showImage.visible ? classes.thumbnailTooltip : classes.hideImage}
                src={showImage.image}
                type="image/png"
                alt=""
            />
            {/* <div
                className={showImage.visible ? classes.thumbnailTooltip : classes.hideImage}
                data={showImage.image}
                type="image/png"
            >
                <img
                    className={showImage.visible ? classes.thumbnailTooltip : classes.hideImage}
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAikAAAEYBAMAAABrc3u4AAAALHRFWHRDcmVhdGlvbiBUaW1lAFdlZCAyNyBNYXIgMjAxOSAxODo1MTo0NyArMDkzMOWZz+IAAAAHdElNRQfjAxsIHCk2av1LAAAACXBIWXMAAAsSAAALEgHS3X78AAAABGdBTUEAALGPC/xhBQAAAANQTFRFlJylJii/hwAAAGJJREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4NDAfAAHd3L3XAAAAAElFTkSuQmCC"
                    alt=""
                />
            </div> */}
        </div>
    );

    return (
        <>
            {addImagePop()}
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader size="small" aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                        className={classes.headingCell}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                                <TableCell key={"Edit"} className={classes.headingCell}></TableCell>
                                <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows &&
                                rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                    let hide = false;
                                    if (
                                        searchFilter &&
                                        !JSON.stringify(row).toUpperCase().includes(searchFilter.toUpperCase())
                                    )
                                        hide = true;

                                    return (
                                        <TableRow
                                            key={index + row.id}
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            style={hide ? { display: "none" } : {}}
                                        >
                                            {columns.map((column) => {
                                                let value = row[column.id];
                                                if (column.id.includes(".")) {
                                                    let section = column.id.split(".")[0];
                                                    let subsection = column.id.split(".")[1];
                                                    value = row[section][subsection];
                                                }

                                                if (column.id === "Pin" && row.pinned)
                                                    return (
                                                        <TableCell
                                                            key={row.code + "-" + column.id}
                                                            align={column.align}
                                                            className={classes.rowCell}
                                                        >
                                                            <img alt="pin" src={BaseURL("/images/ly-pin.svg")} />
                                                        </TableCell>
                                                    );

                                                if (column.id === "Address.FormattedStreetAddress")
                                                    value = row["Address"]["FormattedAddress"].split(",")[0].trim();
                                                if (column.id === "DesignSummary") {
                                                    return (
                                                        <TableCell
                                                            key={row.code + "-" + column.id}
                                                            align={column.align}
                                                            className={classes.rowCell}
                                                        >
                                                            {value ? value : "[Design not defined]"}
                                                            <br />
                                                        </TableCell>
                                                    );
                                                }
                                                if (column.id === "Thumbnail") {
                                                    let image_url = API_BASE() + "svg/" + row.id + "/layout.svg";

                                                    return (
                                                        <TableCell
                                                            onMouseEnter={(e) => MouseOver(row.id, e)}
                                                            onMouseLeave={(e) => MouseOut(row.id, e)}
                                                            key={row.code + "-" + column.id}
                                                            align={column.align}
                                                            className={classes.rowCell}
                                                        >
                                                            <object
                                                                className={classes.thumbnail}
                                                                data={image_url}
                                                                type="image/png"
                                                                onClick={() => handleClickOpen(image_url)}
                                                            >
                                                                <img
                                                                    className={classes.thumbnail}
                                                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAikAAAEYBAMAAABrc3u4AAAALHRFWHRDcmVhdGlvbiBUaW1lAFdlZCAyNyBNYXIgMjAxOSAxODo1MTo0NyArMDkzMOWZz+IAAAAHdElNRQfjAxsIHCk2av1LAAAACXBIWXMAAAsSAAALEgHS3X78AAAABGdBTUEAALGPC/xhBQAAAANQTFRFlJylJii/hwAAAGJJREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4NDAfAAHd3L3XAAAAAElFTkSuQmCC"
                                                                    alt=""
                                                                />
                                                            </object>
                                                        </TableCell>
                                                    );

                                                    // return (
                                                    //     <TableCell
                                                    //         key={row.code + "-" + column.id}
                                                    //         align={column.align}
                                                    //         className={classes.rowCell}
                                                    //     >
                                                    //         <CustomTooltip
                                                    //             arrow
                                                    //             title={
                                                    //                 <>
                                                    //                     <object
                                                    //                         className={classes.thumbnailTooltip}
                                                    //                         data={image_url}
                                                    //                         type="image/png"
                                                    //                         onClick={() => handleClickOpen(image_url)}
                                                    //                     >
                                                    //                         <img
                                                    //                             className={classes.thumbnailTooltip}
                                                    //                             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAikAAAEYBAMAAABrc3u4AAAALHRFWHRDcmVhdGlvbiBUaW1lAFdlZCAyNyBNYXIgMjAxOSAxODo1MTo0NyArMDkzMOWZz+IAAAAHdElNRQfjAxsIHCk2av1LAAAACXBIWXMAAAsSAAALEgHS3X78AAAABGdBTUEAALGPC/xhBQAAAANQTFRFlJylJii/hwAAAGJJREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4NDAfAAHd3L3XAAAAAElFTkSuQmCC"
                                                    //                             alt=""
                                                    //                         />
                                                    //                     </object>
                                                    //                 </>
                                                    //             }
                                                    //         >
                                                    //             <object
                                                    //                 className={classes.thumbnail}
                                                    //                 data={image_url}
                                                    //                 type="image/png"
                                                    //                 onClick={() => handleClickOpen(image_url)}
                                                    //             >
                                                    //                 <img
                                                    //                     className={classes.thumbnail}
                                                    //                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAikAAAEYBAMAAABrc3u4AAAALHRFWHRDcmVhdGlvbiBUaW1lAFdlZCAyNyBNYXIgMjAxOSAxODo1MTo0NyArMDkzMOWZz+IAAAAHdElNRQfjAxsIHCk2av1LAAAACXBIWXMAAAsSAAALEgHS3X78AAAABGdBTUEAALGPC/xhBQAAAANQTFRFlJylJii/hwAAAGJJREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4NDAfAAHd3L3XAAAAAElFTkSuQmCC"
                                                    //                     alt="Stack Overflow logo and icons and such"
                                                    //                 />
                                                    //             </object>
                                                    //         </CustomTooltip>
                                                    //     </TableCell>
                                                    // );
                                                }
                                                if (column.id === "Status") {
                                                    return (
                                                        // eslint-disable-next-line react/jsx-pascal-case
                                                        <BSL_StatusChip status={row.Status} job_id={row.id} />
                                                    );
                                                }
                                                return (
                                                    <TableCell
                                                        key={row.code + "-" + column.id}
                                                        align={column.align}
                                                        onClick={
                                                            column.id === "Customer.JobName"
                                                                ? (event) =>
                                                                      openJob(event, row.id, row.Customer.JobName)
                                                                : () => {}
                                                        }
                                                        className={classes.rowCell}
                                                        style={column.style ? column.style : {}}
                                                    >
                                                        {column.format && value !== undefined
                                                            ? column.format(value, row)
                                                            : value}
                                                    </TableCell>
                                                );
                                            })}
                                            <TableCell
                                                key={row.code + "-Edit"}
                                                className={classes.rowCell + " " + classes.editButton}
                                                onClick={(event) => openJob(event, row.id, row.Customer.JobName)}
                                            >
                                                EDIT
                                            </TableCell>
                                            <TableCell key={row.code + "-Menu"} className={classes.rowCell}>
                                                <IconButton
                                                    className={classes.moreButton}
                                                    onClick={(e) => {
                                                        handleMenuClick(e, row.id);
                                                    }}
                                                >
                                                    <MoreVertIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                        {rows.length === 0 && <div className={classes.no_job_message}>{noJobMessage}</div>}
                    </Table>
                </TableContainer>
                {/* <TablePagination
        // rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      /> */}
                <SimpleDialog image_url={img_url_show} open={open} onClose={handleClose} />

                <ContextMenu
                    id="customized-menu"
                    menuAnchor={menuAnchor}
                    open={Boolean(menuAnchor)}
                    onClose={handleMenuClose}
                    disableScrollLock={true}
                >
                    <ContextMenuItem onClick={handlePinJob}>Pin / UnPin</ContextMenuItem>
                    {user.Role >= 91 && (
                        <ContextMenuItem disabled onClick={handlePinJob}>
                            ERP Numbers
                        </ContextMenuItem>
                    )}
                    <ContextMenuItem onClick={handleDuplicateQuote}>Duplicate Job</ContextMenuItem>
                    <ContextMenuItem disabled>Archive Job</ContextMenuItem>
                    <ContextMenuItem disabled>Delete Job</ContextMenuItem>
                </ContextMenu>
            </Paper>
        </>
    );
}

const useStyles2 = makeStyles({
    root: {},
    media: {
        // ⚠️ object-fit is not supported by IE 11.
        objectFit: "contain",
        width: "93%",
        height: "93%",
        padding: "10px 20px",
    },
});

function SimpleDialog(props) {
    const classes = useStyles2();
    const { onClose, selectedValue, open, image_url } = props;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            PaperProps={{ style: { width: "80%", height: "80%", maxWidth: "80%" } }}
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={open}
        >
            <object className={classes.media} data={image_url} type="image/png">
                <img
                    className={classes.media}
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAikAAAEYBAMAAABrc3u4AAAALHRFWHRDcmVhdGlvbiBUaW1lAFdlZCAyNyBNYXIgMjAxOSAxODo1MTo0NyArMDkzMOWZz+IAAAAHdElNRQfjAxsIHCk2av1LAAAACXBIWXMAAAsSAAALEgHS3X78AAAABGdBTUEAALGPC/xhBQAAAANQTFRFlJylJii/hwAAAGJJREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4NDAfAAHd3L3XAAAAAElFTkSuQmCC"
                    alt="Stack Overflow logo and icons and such"
                />
            </object>
        </Dialog>
    );
}
